import { EventBus } from '@/EventBus';
import * as turf from '@turf/turf';

function popupHTML(result) {
    const getService = (id) =>
        window.app.servicePoints.find((s) => +s.properties.id === +id);
    const sortServices = (a, b) => {
        let score =
            a.properties.type > b.properties.type
                ? 10
                : a.properties.type < b.properties.type
                ? -10
                : 0;
        return a.properties.orgName < b.properties.orgName
            ? score + 1
            : score - 1;
    };
    function serviceHTML(service) {
        const org = window.app.servicePoints.find(
            (s) =>
                +s.properties.orgId === +service.properties.orgId &&
                s.properties.type === 'organisation'
        );
        if (service.properties.type === 'organisation') {
            return `<b>${org.properties.orgName}</b> (centre)`;
        } else {
            return `<b>${org.properties.orgName}</b><br><small>Servicing ${service.properties.locationName}</small>`;
        }
    }
    function groupLocations(services) {
        return services.reduce((groups, service) => ({
            ...groups,
            [service.locationName]: [
                ...(groups[service.locationName] || []),
                service,
            ],
        }));
    }
    const services = (result.properties.ids || String(result.properties.id))
        .split(/[^\d]/)
        .filter(Boolean)
        .map(getService)
        .sort(sortServices);
    return services.map(serviceHTML).join('<br/>');

    // .join('<br/>');
}

function updateLines({ map, results, center }) {
    const lines = [];
    if (center) {
        lines.push(
            ...results.features
                .slice(0, 5)
                .map((r) => turf.lineString([r.geometry.coordinates, center]))
        );
    }
    map.U.addGeoJSON('routes', turf.featureCollection(lines));
    map.U.addLine('routes-lines', 'routes', {
        lineColor: 'red',
        lineWidth: 3,
        lineOpacity: 0.5,
        lineDasharray: [4, 8],
        visibility: 'none',
    });
}

export default async function init(map, { categories, selectedId = -1 }) {
    const first = !map.getSource('results');
    if (first) {
        map.U.addGeoJSON('results', undefined, {
            cluster: true,
            clusterRadius: 10,
            clusterProperties: {
                ids: ['concat', ['concat', ['get', 'id'], ',']],
                orgIds: ['concat', ['concat', ['get', 'orgId'], ',']],
                orgNames: ['concat', ['concat', ['get', 'orgName'], ',']],
                locationNames: [
                    'concat',
                    ['concat', ['get', 'locationName'], ','],
                ],
            },
        });
    }
    map.U.addCircle('results-circle', 'results', {
        circleRadius: ['case', ['==', ['get', 'type'], 'organisation'], 10, 4],
        circleColor: 'hsl(140,80%,50%)',
        circleStrokeColor: 'hsl(140,80%,20%)',
        circleStrokeWidth: 1,
        visibility: 'none',
        // filter: !categories ? true : ['!=', categories, ''],
    });
    map.U.addSymbol('results-pin', 'results', {
        iconImage: [
            // 'case',
            // ['to-boolean', ['get', 'cluster']],
            // 'pin-red-cluster',
            // 'pin-red-outline',
            'case',
            [
                'in',
                `,${selectedId},`,
                [
                    'concat',
                    ',',
                    ['to-string', ['coalesce', ['get', 'id'], ['get', 'ids']]],
                    ',',
                ],
            ],
            [
                'case',
                ['to-boolean', ['get', 'cluster']],
                'pin-cluster-selected',
                'pin-selected',
            ],
            ['case', ['to-boolean', ['get', 'cluster']], 'pin-cluster', 'pin'],
        ],
        iconAnchor: 'bottom',
        iconAllowOverlap: true,
        // iconOffset: [0, 5],
        iconOffset: [0, 0], // wait why was this 5?
        textField: [
            'case',
            ['to-boolean', ['get', 'cluster']],
            '',
            // ['get', 'orgName'],
            [
                'format',
                ['get', 'orgName'],
                '\n',
                ['get', 'locationName'],
                { 'font-scale': 0.8 },
            ],
        ],
        // textVariableAnchor: ['left', 'right', 'bottom'],
        textAnchor: 'left',
        textOffset: [0.7, -1],
        textHaloColor: 'hsla(0,0%,100%,0.6)',
        textHaloWidth: 3,
        textFont: [
            'case',
            ['==', ['get', 'id'], selectedId],
            ['literal', ['DIN Pro Bold']],
            ['literal', ['DIN Pro Regular']],
        ],
    });

    /*

    'case',
            [
                'in',
                `,${selectedId},`,
                [
                    'concat',
                    ',',
                    ['to-string', ['coalesce', ['get', 'id'], ['get', 'ids']]],
                    ',',
                ],
            ],
            ['to-boolean', ['get', 'cluster']],
            'pin-red-cluster-selected',
            'pin-red-outline-selected',

            ['to-boolean', ['get', 'cluster']],
            'pin-red-cluster',
            'pin-red-outline',
        ],*/
    if (first) {
        EventBus.$on('results-change', ({ results, center }) => {
            map.U.setData(
                'results',
                results ? results : { type: 'FeatureCollection', features: [] }
            );
            updateLines({ map, results, center });
        });
        map.U.hoverPopup(/^results/, (l) => popupHTML(l), { anchor: 'left' });
        map.U.hoverPointer(/^results/);
        map.on('click', 'results-pin', (e) => {
            const f = e.features[0];
            const firstServiceId = f.properties.cluster
                ? f.properties.ids.split(',')[0]
                : String(f.properties.id);
            EventBus.$emit('result-pin-click', {
                ...f,
                firstServiceId,
            });
        });
        // map.on('click', 'results-circle', (e) => {
        //     // TODO resync
        //     EventBus.$emit('result-click', e.features[0]);
        // });
    }
}
